import styles from './EditableTableList.module.scss';
export const isEmptyValue = (value)=>value == null || value === '' || value === false;
const NO_BI = true;
export const buttonBi = (config)=>config != null ? {
        bi: config
    } : {
        noBi: NO_BI
    };
export const resolveReorderIndices = (rowIds, event)=>{
    const { active, over } = event;
    if (over == null || active.id === over.id) return null;
    const fromIndex = rowIds.indexOf(String(active.id));
    const toIndex = rowIds.indexOf(String(over.id));
    if (fromIndex === -1 || toIndex === -1) return null;
    return {
        fromIndex,
        toIndex
    };
};
export const columnWidthClass = (column)=>{
    if (column.grow) return styles.growColumn;
    if (column.width != null || column.maxWidth != null) return styles.cappedColumn;
    return styles.shrinkColumn;
};
export const columnWidthStyle = (column)=>{
    if (column.width != null) return {
        width: column.width,
        minWidth: column.width,
        maxWidth: column.width
    };
    return column.maxWidth != null ? {
        maxWidth: column.maxWidth
    } : undefined;
};
